import AcademicInfoGroup from './model';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'id':
      return [key, `${val}`];  // stringify
    default:
      return [key, val];
  }
};

const create = (data) => new AcademicInfoGroup(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/AcademicInfo/AcademicInfoGroup/create.js